import React, { useState } from "react";

import Page from "components/Page";
import { SelectIndicator } from "components/Select";
import { IndicatorsList } from "./components/ListIndicators";
import { WidgetsIndicators } from "./components/WidgetDashboard";

import { Outlet } from "react-router"
import {Shortcuts} from "components/Shortcuts";


const DashboardIndicators = () => {

    const [selected, setSelected] = useState(null);
    const [yearReference, setYearReference] = useState('2025')

    return (
        <Page label="Painel de indicadores" icon="bi bi-grid">

            <div className="card border-0 shadow-sm mt-4">
                <div className="card-body">
                    <div className="row">
                        <div className="col-3 col-xl-2">
                            <select
                                className="form-select"
                                onChange={(e) => setYearReference(e.target.value) }
                                defaultValue={yearReference}
                            >
                                <optgroup label="Ano de publicação">
                                    <option value="2021">2021</option>
                                    <option value="2022">2022</option>
                                    <option value="2023">2023</option>
                                    <option value="2024">2024</option>
                                    <option value="2025">2025</option>
                                </optgroup>
                            </select>
                        </div>
                        <div className="col-9 col-xl-10">
                            <SelectIndicator handleOnChange={(e) => { setSelected(e) }} yearReference={yearReference}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-xl-7 order-1 order-xl-0">
                    <IndicatorsList selected={selected} year_reference={yearReference} />
                </div>
                <div className="col-12 col-xl-5 order-0 order-xl-1">
                    <WidgetsIndicators/>
                    <Shortcuts />
                </div>
            </div>
            <Outlet />
        </Page>
    );
}

export default DashboardIndicators
